/**
 * @generated SignedSource<<548a71ffef163ee501e513c25171e531>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ViewDeleteMutation$variables = {
  id: number;
};
export type ViewDeleteMutation$data = {
  readonly deleteView: {
    readonly globalId: string;
  };
};
export type ViewDeleteMutation = {
  response: ViewDeleteMutation$data;
  variables: ViewDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteViewPayload",
        "kind": "LinkedField",
        "name": "deleteView",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteViewPayload",
        "kind": "LinkedField",
        "name": "deleteView",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "globalId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c7d38e5819204222e4f53838fc1e8455",
    "id": null,
    "metadata": {},
    "name": "ViewDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation ViewDeleteMutation(\n  $id: Int!\n) {\n  deleteView(input: {id: $id}) {\n    globalId\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fc75dac18aa5546c4545390223ffce4";

export default node;
